module.exports = __webpack_public_path__ + "newWebTMS/img/compass-rose.97a0259b.png";